import { createContext } from 'react'
import { DataContextProps, ViewportContextProps } from './types'

export const DataContext = createContext<DataContextProps | undefined>(undefined)
export const ViewportContext = createContext<ViewportContextProps | undefined>(undefined)
